module.exports = __webpack_public_path__ + "static/media/ic_a.6cb2d11d.svg";